import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';
import React, { createContext, useMemo } from 'react';

import { useUserInfo } from '../hooks/useUserInfo';

import type { FC, ReactNode } from 'react';

export type GtmContextValue = {
  // add args
};

export const GtmContext = createContext<GtmContextValue>({});

type GtmContextProps = {
  children: ReactNode;
};

export const GtmProvider: FC<GtmContextProps> = (props) => {
  const { children } = props;
  const { userInfo } = useUserInfo();
  const gtmParams = {
    id: process.env.REACT_APP_GTM_CONTAINER_ID ?? 'invalid_gtm_id',
    dataLayer: {
      user_id: userInfo?.uuid,
      role: userInfo?.role,
      database: userInfo?.database,
      organization_name: userInfo?.organizationName,
      user_name: (userInfo?.lastName|| '') + (userInfo?.firstName|| '')
    },
  };

  const value = useMemo(() => ({}), []);

  if (!userInfo?.id) {
    return <GtmContext.Provider value={value}>{children}</GtmContext.Provider>;
  }

  return (
    <GTMProvider state={gtmParams}>
      <GtmContext.Provider value={value}>{children}</GtmContext.Provider>
    </GTMProvider>
  );
};
